import { IAutoMapper } from "../../../../../core/automapper/interfaces";
import { StringHelper } from "../../../../../utilities/contracts/string-helper";


export const mapHighRiskCategory = (automapper: IAutoMapper): void => {
automapper
  .createMap("HighRiskCategory", "SelectableInput")
  .forMember("text", o => o.name)
  .forMember("value", o => o.categoryID)
  .forMember("extra", o => ({
    categoryCode: o.categoryCode,
  }));
};

export class HighRiskCategoryGroup {
  categoryID: number;
  categoryCode?: string;
  name?: string;

  constructor(options: {
    categoryID: number;
    categoryCode?: string;
    name?: string;
  }) {
    this.categoryID = options.categoryID;
    this.categoryCode = StringHelper.clean(options.categoryCode);
    this.name = StringHelper.clean(options.name);
  }
}
